"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vercelWaitUntil = vercelWaitUntil;

var _worldwide = require("./worldwide.js");

/**
 * Function that delays closing of a Vercel lambda until the provided promise is resolved.
 *
 * Vendored from https://www.npmjs.com/package/@vercel/functions
 */
function vercelWaitUntil(task) {
  const vercelRequestContextGlobal = // @ts-expect-error This is not typed
  _worldwide.GLOBAL_OBJ[Symbol.for('@vercel/request-context')];

  const ctx = vercelRequestContextGlobal && vercelRequestContextGlobal.get && vercelRequestContextGlobal.get() ? vercelRequestContextGlobal.get() : {};

  if (ctx && ctx.waitUntil) {
    ctx.waitUntil(task);
  }
}